import { BrowserRouter, Route, Routes } from "react-router-dom";
import CreateUser from "../features/admin/CreateUser";
import ListUsers from "../features/admin/ListUsers";
import UpdateUser from "../features/admin/UpdateUser";
import Login from "../features/auth/Login";
import PageContainer from "./PageContainer";

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={"/login"} element={<Login />} />
                <Route element={<PageContainer />}>
                    <Route index element={<ListUsers />} />
                    <Route path={"/user/create"} element={<CreateUser />} />
                    <Route path={"/user/update/:id"} element={<UpdateUser />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
